<template>
  <div>
    <ComModal
      ref="comModal"
      :closeable="false"
      :maskClickClose="false"
      :content="content"
      @confirm="handleConfirm"
    >
      <div slot="title">{{ !failed ? '签到成功' : '签到失败' }}</div>

      <div slot="desc" v-if="failed">请重新扫码签到</div>

      <div slot="btn-confirm">{{ !failed ? '查看活动详情' : '确定' }}</div>
    </ComModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import service from '../../service'
import ComModal from '../../components/modal/ComModal.vue'
import utils from '../../util'

export default {
  name: '',
  data: () => ({
    content: '',
    failed: false
  }),
  components: {
    ComModal
  },
  computed: {
    ...mapState([
      'isLogin'
    ]),
    eventid () {
      return this.$route.query.event_id
    },
    code () {
      return this.$route.query.code
    },
    href () {
      return window.location.href
    }
  },
  created () {},
  methods: {
    getActivitySignin (data) {
      service.getActivitySignin(data)
        .then(res => {
          if (res.result) {
            this.content = `您已在${res.data.title}活动中签到`
            if (this.$refs.comModal) this.$refs.comModal.show()
          }
        })
        .catch(() => {
          this.failed = true
          if (this.$refs.comModal) this.$refs.comModal.show()
        })
    },

    handleConfirm () {
      if (utils.isInWXMiniProgram()) {
        window.wx.miniProgram.navigateBack({ delta: 1 })
      } else {
        this.$router.push({ name: 'eventdetail', params: { id: this.eventid } })
      }
    }
  },
  watch: {
    isLogin: {
      handler: function (n) {
        if (!n) {
          utils.login()
        } else {
          if (this.eventid && this.code) {
            this.getActivitySignin({ event_id: this.eventid, code: this.code })
          } else {
            this.$Message.info({ message: '页面参数不完整，请稍后再试', top: '100px', single: true })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" module>
</style>
